import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import { localizeRouteKey } from "@/utils/common.ts";
import { AppRoute } from "@/routes";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { ReactElement } from "react";
import kaikkiJarjestajat from "@/i18n/definitions/kaikkiJarjestajat.ts";

export default function JarjestajatCard(): ReactElement {
  const history = useHistory();
  const intl = useIntl();
  const { formatMessage, locale } = intl;

  return (
    <Card>
      <CardActionArea
        onClick={() => {
          history.push(
            localizeRouteKey(locale, AppRoute.KaikkiJarjestajat, intl)
          );
        }}>
        <CardContent>
          <Typography gutterBottom variant="h3" component="h3">
            {formatMessage(kaikkiJarjestajat.kortinOtsikko)}
          </Typography>
          <Typography gutterBottom component="p">
            {formatMessage(kaikkiJarjestajat.lyhytKuvaus)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}